import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import {
  IconAlignCenter,
  IconAlignLeft,
  IconAlignRight,
  IconItalic,
  IconLetterB,
  IconLetterU,
  IconMinus,
  IconPlus,
  IconX
} from '@tabler/icons';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { store } from 'store';
import { SET_ITEMS } from 'store/actions';
import MainCard from 'ui-component/cards/MainCard';
import {
  GENDERORIENTED_OPTIONS,
  GENDERORIENTED_OPTIONS_FR,
  GENDER_OPTIONS,
  GENDER_OPTIONS_FR,
  RELATIONSHIP_OPTIONS,
  RELATIONSHIP_OPTIONS_FR,
  SEX_OPTIONS,
  SEX_OPTIONS_FR
} from 'utils/constants';
import { v4 as uuid } from 'uuid';

const NewProperties = ({ selectedItem, setSelectedItem, setItems, language, isDashboard = false, propertiesRef, items }: any) => {
  const intl = useIntl();
  let mousePressedIntervalRef = useRef<any>();
  useEffect(() => {
    store.dispatch({ type: SET_ITEMS, payload: items });
  }, [items]);

  const presetOptions = [
    { id: '', label: intl.formatMessage({ defaultMessage: 'None' }) },
    {
      id: 'gender',
      label: intl.formatMessage({ defaultMessage: 'Gender' })
    },
    {
      id: 'sex',
      label: intl.formatMessage({ defaultMessage: 'Sex' })
    },
    {
      id: 'genderOrientation',
      label: intl.formatMessage({ defaultMessage: 'Gender Orientation' })
    },
    {
      id: 'relationship',
      label: intl.formatMessage({ defaultMessage: 'Relationship' })
    }
  ];
  const [value, setValue] = useState('');
  const [radioValue, setRadioValue] = useState(12);
  const [legendRadioValue, setLegendRadioValue] = useState(selectedItem?.legendRadioValue ?? '');

  const [labelFrench, setlabelFrench] = useState('');

  const [preset, setPreset] = useState<any>(null);
  const [autocompleteValues, setAutocompleteValues] = useState<any>([]);
  const [questionnaireValues, setQuestionnaireValues] = useState<any>([]);
  const [description, setDescription] = useState<any>({
    label: selectedItem?.description?.label || '',
    labelFrench: selectedItem?.description?.labelFrench || ''
  });
  const [choices, setChoices] = useState<any>(selectedItem?.choices ? selectedItem?.choices : []);
  const [legend, setLegend] = useState<any>(selectedItem?.legend ? selectedItem?.legend : []);
  const [inputsLabel, setInputsLabel] = useState('');
  const [inputsLabelFrench, setInputsLabelFrench] = useState('');
  useEffect(() => {
    return () => {
      if (mousePressedIntervalRef.current) {
        clearInterval(mousePressedIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    var label = selectedItem.type === 'Image' ? 'Logo' : selectedItem.label;
    setValue(label || '');
    setlabelFrench(selectedItem.labelFrench || '');
    setAutocompleteValues(selectedItem.items ? [...selectedItem.items] : []);
    setQuestionnaireValues(selectedItem.items ? [...selectedItem.items] : []);
    setInputsLabel(selectedItem.inputsLabel);
    setInputsLabelFrench(selectedItem.inputsLabelFrench);
    switch (selectedItem?.width) {
      case 12: {
        setRadioValue(12);
        break;
      }
      case 6: {
        setRadioValue(6);
        break;
      }
      case 4: {
        setRadioValue(4);
        break;
      }
      default: {
        setRadioValue(12);
      }
    }
  }, [
    selectedItem.label,
    selectedItem.items,
    selectedItem.type,
    selectedItem.labelFrench,
    selectedItem.inputsLabel,
    selectedItem.inputsLabelFrench,
    selectedItem?.width
  ]);

  const handleChange = useCallback(
    (property, value) => {
      let key = setSelectedItem((pre) => ({ ...pre, [property]: value }));
      setItems((pre) => {
        const foundItem = pre.find((i) => i.id === selectedItem.id);
        if (foundItem) {
          foundItem[property] = value;
        }
        store.dispatch({ type: SET_ITEMS, payload: pre });
        return pre;
      });
    },
    [selectedItem.id, setItems, setSelectedItem]
  );

  useEffect(() => {
    if (preset) {
      let options;

      switch (preset?.id) {
        case 'gender':
          options = GENDER_OPTIONS.map((label, index) => ({ id: uuid(), label, labelFrench: GENDER_OPTIONS_FR[index] }));
          break;
        case 'sex':
          options = SEX_OPTIONS.map((label, index) => ({ id: uuid(), label, labelFrench: SEX_OPTIONS_FR[index] }));
          break;
        case 'genderOrientation':
          options = GENDERORIENTED_OPTIONS.map((label, index) => ({ id: uuid(), label, labelFrench: GENDERORIENTED_OPTIONS_FR[index] }));
          break;
        case 'relationship':
          options = RELATIONSHIP_OPTIONS.map((label, index) => ({ id: uuid(), label, labelFrench: RELATIONSHIP_OPTIONS_FR[index] }));
          break;
      }

      if (options?.length) {
        setAutocompleteValues([...options]);
        handleChange('items', options);
      }
    }
  }, [handleChange, preset]);

  const addAutocompleteItem = () => {
    setAutocompleteValues((pre) => [...pre, { id: '', label: '', labelFrench: '' }]);
  };

  const addNewAutocompleteItemQuestionnaire = () => {
    setQuestionnaireValues((pre) => [
      ...pre,
      {
        id: '',
        label: '',
        labelFrench: '',
        value: ''
      }
    ]);
  };
  const AddChoice = () => {
    setChoices((pre) => [...pre, { id: '', value: '', label: '', labelFrench: '' }]);
  };
  const AddLegend = () => {
    setLegend((pre) => [...pre, { id: '', value: '', label: '', labelFrench: '', lowerLimit: '', upperLimit: '' }]);
  };

  const handleChangeRadioGroup = useCallback(
    (_, value) => {
      setRadioValue(value);
      let VALUE = 12;

      if (Number(value) === 4) {
        VALUE = 4;
      }

      if (Number(value) === 6) {
        VALUE = 6;
      }
      setSelectedItem((pre) => ({ ...pre, width: VALUE }));
      setItems((pre) => {
        const foundItem = pre.find((i) => i.id === selectedItem.id);
        if (foundItem) {
          foundItem.width = VALUE;
        }
        store.dispatch({ type: SET_ITEMS, payload: pre });
        return pre;
      });
    },
    [selectedItem.id, setItems, setSelectedItem]
  );

  const handleChangeLegendRadioGroup = useCallback(
    (_, value) => {
      setLegendRadioValue(value);

      setSelectedItem((pre) => ({ ...pre, legendRadioValue: value }));
      setItems((pre) => {
        const foundItem = pre.find((i) => i.id === selectedItem.id);
        if (foundItem) {
          foundItem.legendRadioValue = value;
        }
        store.dispatch({ type: SET_ITEMS, payload: pre });
        return pre;
      });
    },
    [selectedItem.id, setItems, setSelectedItem]
  );

  return (
    <MainCard content={false} ref={propertiesRef}>
      <Stack
        p={2}
        spacing={4}
        mt={2}
        sx={{
          '& .MuiAccordionSummary-root': {
            m: '0 !important',
            p: '0 !important'
          },
          '& .MuiAccordionDetails-root': {
            m: '0 !important',
            p: '0 !important'
          },
          '& .MuiAccordion-gutters': {
            m: '0 !important'
          }
        }}
      >
        <Stack>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            onChange={handleChangeRadioGroup}
            value={radioValue}
          >
            <FormControlLabel value={12} control={<Radio />} label="Full Width" />
            <FormControlLabel value={6} control={<Radio />} label="Half Width" />
            <FormControlLabel value={4} control={<Radio />} label="Small Width" />
          </RadioGroup>

          {!['Logo', 'Text'].includes(selectedItem.type) && (
            <FormControlLabel
              control={<Checkbox onChange={(e) => handleChange('mandatory', e.target.checked)} checked={selectedItem.mandatory} />}
              label={<FormattedMessage defaultMessage="Mandatory Field" />}
            />
          )}
        </Stack>
        {!isDashboard && (
          <>
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 'bold' }}>
                  <FormattedMessage defaultMessage="Field Name" />
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={3} my={3}>
                  {language?.includes('en') && (
                    <TextField
                      label={<FormattedMessage defaultMessage="Field name (EN)" />}
                      value={value}
                      multiline
                      onChange={(e) => setValue(e.target.value)}
                      onBlur={(e) => {
                        handleChange('label', e.target.value);
                      }}
                      size="small"
                      fullWidth
                    />
                  )}

                  {language?.includes('fr') && (
                    <TextField
                      label={<FormattedMessage defaultMessage="Field name (FR)" />}
                      value={labelFrench}
                      onChange={(e) => setlabelFrench(e.target.value)}
                      onBlur={(e) => {
                        handleChange('labelFrench', e.target.value);
                      }}
                      size="small"
                      fullWidth
                      multiline
                    />
                  )}
                </Stack>
              </AccordionDetails>
            </Accordion>

            {selectedItem.type === 'Questionnaire' && (
              <>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      <FormattedMessage defaultMessage="Description" />
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack alignItems="center" spacing={3} py={3}>
                      {language?.includes('en') && (
                        <TextField
                          label={intl.formatMessage({ defaultMessage: 'Description (EN)' })}
                          value={description.label ?? ''}
                          onChange={(e) => {
                            setDescription({ ...description, label: e.target.value });
                          }}
                          onBlur={(e) => {
                            handleChange('description', description);
                          }}
                          size="small"
                          fullWidth
                        />
                      )}

                      {language?.includes('fr') && (
                        <TextField
                          label={intl.formatMessage({ defaultMessage: 'Description (FR)' })}
                          value={description?.labelFrench ?? ''}
                          onChange={(e) => {
                            setDescription({ ...description, labelFrench: e.target.value });
                          }}
                          onBlur={(e) => {
                            handleChange('description', description);
                          }}
                          size="small"
                          fullWidth
                        />
                      )}
                    </Stack>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      <FormattedMessage defaultMessage="List Items" />
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack spacing={3} py={3}>
                      {questionnaireValues.map((v, index) => (
                        <Stack key={index} direction="row" alignItems="center" spacing={1}>
                          {language?.includes('en') && (
                            <TextField
                              label={intl.formatMessage({ defaultMessage: 'Item (EN)' })}
                              value={v.label ?? ''}
                              onChange={(e) => {
                                setQuestionnaireValues((pre) => {
                                  pre[index].label = e.target.value;
                                  pre[index].id = pre[index].id || uuid();
                                  return [...pre];
                                });
                              }}
                              onBlur={(e) => {
                                handleChange('items', questionnaireValues);
                              }}
                              size="small"
                              fullWidth
                            />
                          )}

                          {language?.includes('fr') && (
                            <TextField
                              label={intl.formatMessage({ defaultMessage: 'Item (FR)' })}
                              value={v?.labelFrench ?? ''}
                              onChange={(e) => {
                                setQuestionnaireValues((pre) => {
                                  pre[index].labelFrench = e.target.value;
                                  pre[index].id = pre[index].id || uuid();
                                  return [...pre];
                                });
                              }}
                              onBlur={(e) => {
                                handleChange('items', questionnaireValues);
                              }}
                              size="small"
                              fullWidth
                            />
                          )}

                          <IconButton
                            sx={{ width: 30, height: 30 }}
                            onClick={() => {
                              setQuestionnaireValues((pre) => {
                                pre.splice(index, 1);
                                return [...pre];
                              });

                              setTimeout(() => {
                                handleChange('items', questionnaireValues);
                              }, 500);
                            }}
                          >
                            <IconX />
                          </IconButton>
                        </Stack>
                      ))}

                      <Button onClick={addNewAutocompleteItemQuestionnaire}>
                        <FormattedMessage defaultMessage="Add List Item" />
                      </Button>
                    </Stack>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      <FormattedMessage defaultMessage="Choices" />
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack spacing={2}>
                      <FormControlLabel
                        label="Add Scores"
                        control={
                          <Checkbox
                            checked={selectedItem?.addScores}
                            onChange={(e) => {
                              handleChange('addScores', e.target.checked);
                            }}
                          />
                        }
                      />
                      {choices.map((v, index) => (
                        <Stack key={index} direction="row" alignItems="center" spacing={1}>
                          {language?.includes('en') && (
                            <Stack direction="row" gap={0.5}>
                              <TextField
                                label={intl.formatMessage({ defaultMessage: 'Item (EN)' })}
                                value={v.label ?? ''}
                                onChange={(e) => {
                                  setChoices((pre) => {
                                    pre[index].label = e.target.value;
                                    pre[index].id = pre[index].id || uuid();
                                    pre[index].score = v.score;
                                    return [...pre];
                                  });
                                }}
                                onBlur={(e) => {
                                  handleChange('choices', choices);
                                }}
                                size="small"
                                fullWidth
                              />
                              {selectedItem?.addScores && (
                                <TextField
                                  label={intl.formatMessage({ defaultMessage: 'Score' })}
                                  value={v.score === 0 || v.score ? v.score : ''}
                                  onChange={(e) => {
                                    setChoices((pre) => {
                                      pre[index].label = v.label || '';
                                      pre[index].score = parseInt(e.target.value);
                                      pre[index].id = pre[index].id || uuid();
                                      return [...pre];
                                    });
                                  }}
                                  onBlur={(e) => {
                                    handleChange('choices', choices);
                                  }}
                                  size="small"
                                  fullWidth
                                  type="number"
                                  inputProps={{ min: 0 }}
                                />
                              )}
                            </Stack>
                          )}

                          {language?.includes('fr') && (
                            <TextField
                              label={intl.formatMessage({ defaultMessage: 'Item (FR)' })}
                              value={v?.labelFrench ?? ''}
                              onChange={(e) => {
                                setChoices((pre) => {
                                  pre[index].labelFrench = e.target.value;
                                  pre[index].id = pre[index].id || uuid();
                                  return [...pre];
                                });
                              }}
                              onBlur={(e) => {
                                handleChange('choices', choices);
                              }}
                              size="small"
                              fullWidth
                            />
                          )}

                          <IconButton
                            sx={{ width: 30, height: 30 }}
                            onClick={() => {
                              setChoices((pre) => {
                                pre.splice(index, 1);
                                return [...pre];
                              });

                              setTimeout(() => {
                                handleChange('choices', choices);
                              }, 500);
                            }}
                          >
                            <IconX />
                          </IconButton>
                        </Stack>
                      ))}

                      <Button onClick={AddChoice}>
                        <FormattedMessage defaultMessage="Add Choice" />
                      </Button>
                    </Stack>
                  </AccordionDetails>
                </Accordion>

                {selectedItem?.addScores && (
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography sx={{ fontWeight: 'bold' }}>
                        <FormattedMessage defaultMessage="Legend" />
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Stack gap={1}>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-legend-radio-buttons-group"
                          onChange={handleChangeLegendRadioGroup}
                          value={legendRadioValue}
                        >
                          <FormControlLabel value={'range'} control={<Radio />} label="Range Based Scores" />
                          <FormControlLabel value={'precise'} control={<Radio />} label="Precise Score" />
                        </RadioGroup>
                        {legend.map((v, index) => (
                          <Stack key={index} direction="row" alignItems="center" spacing={1}>
                            {language?.includes('en') && (
                              <Stack direction="row" gap={0.5}>
                                <TextField
                                  label={intl.formatMessage({ defaultMessage: 'Title' })}
                                  value={v.label ?? ''}
                                  onChange={(e) => {
                                    setLegend((pre) => {
                                      pre[index].label = e.target.value;
                                      pre[index].id = pre[index].id || uuid();
                                      return [...pre];
                                    });
                                  }}
                                  onBlur={(e) => {
                                    handleChange('legend', legend);
                                  }}
                                  size="small"
                                  fullWidth
                                />
                                {legendRadioValue === 'range' && (
                                  <TextField
                                    label={intl.formatMessage({ defaultMessage: 'Lower Limit of Score' })}
                                    value={v.lowerLimit === 0 || v.lowerLimit ? v.lowerLimit : ''}
                                    onChange={(e) => {
                                      setLegend((pre) => {
                                        pre[index].label = v.label || '';
                                        pre[index].lowerLimit = parseInt(e.target.value);
                                        pre[index].id = pre[index].id || uuid();
                                        return [...pre];
                                      });
                                    }}
                                    onBlur={(e) => {
                                      handleChange('legend', legend);
                                    }}
                                    size="small"
                                    fullWidth
                                    type="number"
                                    inputProps={{ min: 0 }}
                                  />
                                )}
                                {legendRadioValue === 'range' && (
                                  <TextField
                                    label={intl.formatMessage({ defaultMessage: 'Upper Limit of Score' })}
                                    value={v.upperLimit === 0 || v.upperLimit ? v.upperLimit : ''}
                                    onChange={(e) => {
                                      setLegend((pre) => {
                                        pre[index].label = v.label || '';
                                        pre[index].upperLimit = parseInt(e.target.value);
                                        pre[index].id = pre[index].id || uuid();
                                        return [...pre];
                                      });
                                    }}
                                    onBlur={(e) => {
                                      handleChange('legend', legend);
                                    }}
                                    size="small"
                                    fullWidth
                                    type="number"
                                    inputProps={{ min: 0 }}
                                  />
                                )}
                                {legendRadioValue === 'precise' && (
                                  <TextField
                                    label={intl.formatMessage({ defaultMessage: 'Score' })}
                                    value={v.value === 0 || v.value ? v.value : ''}
                                    onChange={(e) => {
                                      setLegend((pre) => {
                                        pre[index].label = v.label || '';
                                        pre[index].value = parseInt(e.target.value);
                                        pre[index].id = pre[index].id || uuid();
                                        return [...pre];
                                      });
                                    }}
                                    onBlur={(e) => {
                                      handleChange('legend', legend);
                                    }}
                                    size="small"
                                    fullWidth
                                    type="number"
                                    inputProps={{ min: 0 }}
                                  />
                                )}
                              </Stack>
                            )}

                            {language?.includes('fr') && (
                              <TextField
                                label={intl.formatMessage({ defaultMessage: 'Title (FR)' })}
                                value={v?.labelFrench ?? ''}
                                onChange={(e) => {
                                  setLegend((pre) => {
                                    pre[index].labelFrench = e.target.value;
                                    pre[index].id = pre[index].id || uuid();
                                    return [...pre];
                                  });
                                }}
                                onBlur={(e) => {
                                  handleChange('legend', legend);
                                }}
                                size="small"
                                fullWidth
                              />
                            )}

                            <IconButton
                              sx={{ width: 30, height: 30 }}
                              onClick={() => {
                                setLegend((pre) => {
                                  pre.splice(index, 1);
                                  return [...pre];
                                });

                                setTimeout(() => {
                                  handleChange('legend', legend);
                                }, 500);
                              }}
                            >
                              <IconX />
                            </IconButton>
                          </Stack>
                        ))}
                        <Button onClick={AddLegend}>
                          <FormattedMessage defaultMessage="Add Legend" />
                        </Button>
                      </Stack>
                    </AccordionDetails>
                  </Accordion>
                )}

                {/* <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                      <FormattedMessage defaultMessage="Additional Input" />
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack spacing={2}>
                      <FormControlLabel
                        label="Show Text Field Input"
                        control={
                          <Checkbox
                            checked={selectedItem?.showInput}
                            onChange={(e) => {
                              handleChange('showInput', e.target.checked);
                            }}
                          />
                        }
                      />

                      {selectedItem?.showInput && (
                        <>
                          <TextField
                            label={<FormattedMessage defaultMessage="Input name (EN)" />}
                            value={inputsLabel}
                            onChange={(e) => setInputsLabel(e.target.value)}
                            onBlur={(e) => {
                              handleChange('inputsLabel', e.target.value);
                            }}
                            size="small"
                            fullWidth
                          />

                          <TextField
                            label={<FormattedMessage defaultMessage="Input name (FR)" />}
                            value={inputsLabelFrench}
                            onChange={(e) => setInputsLabelFrench(e.target.value)}
                            onBlur={(e) => {
                              handleChange('inputsLabelFrench', e.target.value);
                            }}
                            size="small"
                            fullWidth
                          />
                        </>
                      )}
                    </Stack>
                  </AccordionDetails>
                </Accordion> */}
              </>
            )}

            {(selectedItem.type === 'Autocomplete' || selectedItem.type === 'Checkbox Group' || selectedItem.type === 'Radio Group') && (
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography sx={{ fontWeight: 'bold' }}>
                    <FormattedMessage defaultMessage="Items" />
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Stack spacing={3}>
                    {selectedItem.type === 'Autocomplete' && (
                      <FormControlLabel
                        control={<Checkbox onChange={(e) => handleChange('multiple', e.target.checked)} checked={selectedItem.multiple} />}
                        label={<FormattedMessage defaultMessage="Multiple Select" />}
                      />
                    )}

                    {(selectedItem.type === 'Checkbox Group' || selectedItem.type === 'Radio Group') && (
                      <FormControlLabel
                        control={<Checkbox onChange={(e) => handleChange('vertical', e.target.checked)} checked={selectedItem.vertical} />}
                        label={<FormattedMessage defaultMessage="Vertical" />}
                      />
                    )}

                    <Autocomplete
                      options={presetOptions}
                      isOptionEqualToValue={(option: any, value: any) => option.value === value.id}
                      getOptionLabel={(option: any) => option.label}
                      freeSolo={false}
                      renderInput={(params) => <TextField label={intl.formatMessage({ defaultMessage: 'Preset' })} {...params} />}
                      value={preset}
                      onChange={(e, value) => {
                        setPreset(value);
                        handleChange('preset', value.id);
                      }}
                    />

                    <Stack spacing={2}>
                      {autocompleteValues.map((v, index) => (
                        <Stack key={index} direction="row" alignItems="center" spacing={1}>
                          {language?.includes('en') && (
                            <TextField
                              label={intl.formatMessage({ defaultMessage: 'Item (EN)' })}
                              value={v.label ?? ''}
                              onChange={(e) => {
                                setAutocompleteValues((pre) => {
                                  pre[index].label = e.target.value;
                                  pre[index].id = pre[index].id || uuid();
                                  return [...pre];
                                });
                              }}
                              onBlur={(e) => {
                                handleChange('items', autocompleteValues);
                              }}
                              size="small"
                              fullWidth
                            />
                          )}

                          {language?.includes('fr') && (
                            <TextField
                              label={intl.formatMessage({ defaultMessage: 'Item (FR)' })}
                              value={v.labelFrench ?? ''}
                              onChange={(e) => {
                                setAutocompleteValues((pre) => {
                                  pre[index].labelFrench = e.target.value;
                                  pre[index].id = pre[index].id || uuid();
                                  return [...pre];
                                });
                              }}
                              onBlur={(e) => {
                                handleChange('items', autocompleteValues);
                              }}
                              size="small"
                              fullWidth
                            />
                          )}

                          <IconButton
                            sx={{ width: 30, height: 30 }}
                            onClick={() => {
                              setAutocompleteValues((pre) => {
                                pre.splice(index, 1);
                                return [...pre];
                              });

                              setTimeout(() => {
                                handleChange('items', autocompleteValues);
                              }, 500);
                            }}
                          >
                            <IconX />
                          </IconButton>
                        </Stack>
                      ))}
                      <Button onClick={addAutocompleteItem}>
                        <FormattedMessage defaultMessage="Add Item" />
                      </Button>
                    </Stack>
                  </Stack>
                </AccordionDetails>
              </Accordion>
            )}

            {selectedItem.type === 'Logo' && (
              <>
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  alignSelf="flex-start"
                  sx={{ border: '1px solid #eee', borderRadius: 3 }}
                >
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Logo Size' })}>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      alignSelf="flex-start"
                      sx={{ border: '1px solid #eee', borderRadius: 3 }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => handleChange('logoSize', (selectedItem.logoSize || 14) - 1)}
                        onMouseDown={() => {
                          let logoSize = selectedItem.logoSize || 14;

                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }

                          mousePressedIntervalRef.current = setInterval(() => {
                            if (logoSize > 10) {
                              logoSize = logoSize - 1;
                              handleChange('logoSize', logoSize);
                            } else {
                              clearInterval(mousePressedIntervalRef.current);
                            }
                          }, 200);
                        }}
                        onMouseUp={() => {
                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }
                        }}
                        disabled={selectedItem.logoSize < 11}
                      >
                        <IconMinus size={20} />
                      </IconButton>
                      <Typography>{selectedItem.logoSize || 14}</Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleChange('logoSize', (selectedItem.logoSize || 14) + 1)}
                        onMouseDown={() => {
                          let logoSize = selectedItem.logoSize || 14;

                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }

                          mousePressedIntervalRef.current = setInterval(() => {
                            if (logoSize < 50) {
                              logoSize = logoSize + 1;
                              handleChange('logoSize', logoSize);
                            } else {
                              clearInterval(mousePressedIntervalRef.current);
                            }
                          }, 200);
                        }}
                        onMouseUp={() => {
                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }
                        }}
                        disabled={selectedItem.logoSize > 49}
                      >
                        <IconPlus size={20} />
                      </IconButton>
                    </Stack>
                  </Tooltip>
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Left' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('alignLogo', `left`);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.alignLogo === `left` ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconAlignLeft size={18} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Center' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('alignLogo', `center`);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.alignLogo === `center` ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconAlignCenter size={18} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Right' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('alignLogo', `right`);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.alignLogo === `right` ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconAlignRight size={18} />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </>
            )}
            {selectedItem.type === 'Text' && (
              <>
                <Stack spacing={2} direction="row" alignItems="center">
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Font Size' })}>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      alignSelf="flex-start"
                      sx={{ border: '1px solid #eee', borderRadius: 3 }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => handleChange('fontSize', (selectedItem.fontSize || 14) - 1)}
                        onMouseDown={() => {
                          let fontSize = selectedItem.fontSize || 14;

                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }

                          mousePressedIntervalRef.current = setInterval(() => {
                            if (fontSize > 10) {
                              fontSize = fontSize - 1;
                              handleChange('fontSize', fontSize);
                            } else {
                              clearInterval(mousePressedIntervalRef.current);
                            }
                          }, 200);
                        }}
                        onMouseUp={() => {
                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }
                        }}
                        disabled={selectedItem.fontSize < 11}
                      >
                        <IconMinus size={20} />
                      </IconButton>
                      <Typography>{selectedItem.fontSize || 14}</Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleChange('fontSize', (selectedItem.fontSize || 14) + 1)}
                        onMouseDown={() => {
                          let fontSize = selectedItem.fontSize || 14;

                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }

                          mousePressedIntervalRef.current = setInterval(() => {
                            if (fontSize < 40) {
                              fontSize = fontSize + 1;
                              handleChange('fontSize', fontSize);
                            } else {
                              clearInterval(mousePressedIntervalRef.current);
                            }
                          }, 200);
                        }}
                        onMouseUp={() => {
                          if (mousePressedIntervalRef.current) {
                            clearInterval(mousePressedIntervalRef.current);
                          }
                        }}
                        disabled={selectedItem.fontSize > 39}
                      >
                        <IconPlus size={20} />
                      </IconButton>
                    </Stack>
                  </Tooltip>

                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Bold' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('bold', !selectedItem.bold);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.bold ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconLetterB size={18} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Italic' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('italic', !selectedItem.italic);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.italic ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconItalic size={18} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={intl.formatMessage({ defaultMessage: 'underline' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('underline', !selectedItem.underline);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.underline ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconLetterU size={18} />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <Stack spacing={2} direction="row" alignItems="center">
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Left' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('textAlign', `left`);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.textAlign === `left` ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconAlignLeft size={18} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Center' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('textAlign', `center`);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.textAlign === `center` ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconAlignCenter size={18} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={intl.formatMessage({ defaultMessage: 'Right' })}>
                    <IconButton
                      onClick={() => {
                        handleChange('textAlign', `right`);
                      }}
                      size="small"
                      sx={{
                        borderWidth: 2,
                        borderColor: selectedItem.textAlign === `right` ? '#666' : '#fff',
                        borderStyle: 'solid',
                        borderRadius: 1,
                        p: 0.3
                      }}
                    >
                      <IconAlignRight size={18} />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </>
            )}
          </>
        )}
        <Button variant="contained" onClick={() => setSelectedItem(null)}>
          {intl.formatMessage({ defaultMessage: 'Save Changes' })}
        </Button>
      </Stack>
    </MainCard>
  );
};

export default NewProperties;
